module.exports = __webpack_public_path__ + "Icono_Telefono_126px.png";